import { Injectable } from '@angular/core'
import { Converter } from '@spartacus/core'
import { EbCmsLinkComponent } from '../footer/interfaces/eb-cms.interfaces'

@Injectable()
export class EbCmsLinkComponentNormalizer
  implements Converter<EbCmsLinkComponent, EbCmsLinkComponent>
{
  convert(source: EbCmsLinkComponent, target?: EbCmsLinkComponent): EbCmsLinkComponent {
    if (target === undefined) {
      target = { ...(source as any) }
    }

    target.url = source.localizedUrl ?? source.url

    return target
  }
}
